import WATER_BATH_OPEN from './images/mc_lid_open.svg';
import WATER_BATH_CLOSE_IMG from './images/mc_lid_close.svg';
import WATER_BATH_CONTROLS_IMG from './images/mc_controls.svg';
import EJECT_TUBE_RACK_IMG from './images/mc_eject_rotor.svg';

export function useMicroTooltipControls() {

  const getControlItems = (props) => {
    const newControlItems = [];

    if (!props.isOpen) {
      newControlItems.push({
        onClick: props.toggleLid,
        image: WATER_BATH_OPEN,
      });
    } else {
      newControlItems.push({
        onClick: props.toggleLid,
        image: WATER_BATH_CLOSE_IMG,
      });
    }

    if (props.containsTubeRack) {
      newControlItems.push({
        onClick: props.onEjectTubeRack,
        image: EJECT_TUBE_RACK_IMG,
      });
    }

    newControlItems.push({
      onClick: props.openShowControlsModal,
      image: WATER_BATH_CONTROLS_IMG,
    });

    return newControlItems;
  };

  return {getControlItems};
}
